import { connect, batch } from 'react-redux';

import { actions } from '@amplement/backend-connector';
import BasicNetwork from './index';

const mapDispatchToProps = dispatch => ({
    setNetworkStatus: ({ type }) => batch(() => {
        dispatch(actions.network.updateConnectedStatus(type === 'online'));
        dispatch(actions.network.updateNetworkStatus({ isInternetReachable: type === 'online' }));
    })
});

export default connect(null, mapDispatchToProps)(BasicNetwork);
